/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParamVm
 */
export interface ParamVm {
    /**
     * 
     * @type {boolean}
     * @memberof ParamVm
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ParamVm
     */
    showInMasterView?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ParamVm
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParamVm
     */
    pattern?: string | null;
}

export function ParamVmFromJSON(json: any): ParamVm {
    return ParamVmFromJSONTyped(json, false);
}

export function ParamVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParamVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'showInMasterView': !exists(json, 'showInMasterView') ? undefined : json['showInMasterView'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'pattern': !exists(json, 'pattern') ? undefined : json['pattern'],
    };
}

export function ParamVmToJSON(value?: ParamVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'showInMasterView': value.showInMasterView,
        'displayName': value.displayName,
        'pattern': value.pattern,
    };
}


